import styled from 'styled-components';

export const TopRatedAwardSection = styled.section`
    width: 100%;
    background: #DDF5F6; 
    padding-top: 50px;

    @media screen and (max-width: 1024px){
        padding-top: 178px;
    }
`;

export const TopRatedAwardWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: center;
    row-gap: 20px;
    padding-left: 102px;
`;

export const AwardImage = styled.div`
    width: 100%;
    max-width: 320px;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const AwardTitle = styled.div`
    color: #01606F;
    font-size: 40px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 60px;
`;

export const AwardButton = styled.div`
    width: 100%;    
    max-width: 242px;
    margin: 0 auto;
    button{
        width: 100%;
    }
`;

export const TopRatedAwardImagedWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;    
    margin-top: 0px;

    @media screen and (max-width: 1200px){
        margin-top: 50px;
    }

    @media screen and (max-width: 1024px){
        margin-top: 70px;
    }

    img{
        width: 100%;
        height: auto;
        display: block
    }
`;

export const WhatAreTopRatedAwardSection = styled.section`
    width: 100%;
    padding: 50px 0px;
    background: #F1FEFF;
    
    @media screen and (max-width: 767px){
        padding: 40px 0px;
    }
    
`;

export const WhatAreTopRatedAwardWrap = styled.div`
    width: 100%;
    padding: 20px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0px 5px 30px #0000001A;
    
    @media screen and (max-width: 480px){
        padding: 15px;
    }
`;

export const TopRatedAwardSubTitle = styled.h3`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
`;

export const TopAwardSubBox = styled.div`
    width: 100%;
    background: #F3F3F3;
    border-radius: 10px;
    padding: 20px 15px;
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 15px;

    @media screen and (max-width: 480px){
        row-gap: 20px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        padding: 15px;
    }
`;

export const AwardSubBoxImage = styled.div`
    max-width: 160px;
    width: 100%;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const AwardSubBoxContent = styled.div`
    color: rgb(51 51 51 / 80%);
    font-size: 14px;
    font-weight: 400;
    font-family: 'Jost', sans-serif;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    row-gap: 10px;
`;

export const AwardSubBoxStrongText = styled.strong`
    color: #01606F;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 28px;
`;

export const AwardSubBoxText = styled.p`
    margin-bottom: 0px;
`;

export const WhatAreTopRatedAwardText = styled.div`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 28px;
    padding: 51px 0px;

    @media screen and (max-width: 991px){
        padding: 50px 0px 0px;
    }

    @media screen and (max-width: 767px){
        padding: 40px 0px 0px;
    }
`;

export const WhatAreTopRatedAwardStrongText = styled.span`
    color: #01606F;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 28px;
    cursor: pointer;
`;

export const TopAwardNonprofitsSec = styled.div`
    width: 100%;
    background: #F1FEFF;
`;

export const NonprofitsBox = styled.div`
    width: 100%;
    background: #FFFFFF;
    color: #333333;
    font-size:18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 28px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 25px;
    border: 1px solid #000000;
    border-radius: 15px;
    margin-bottom: 20px;
    &:last-child{margin-bottom: 0px;}

    @media screen and (max-width: 991px){
        row-gap: 15px;
    }

    button{
        max-width: 242px;
        width: 100%;
        box-shadow: 3px 5px 20px #00000033;
        transition: 0.25s ease all;
    }
    .btn-outline-success-blue.form-btn{
        padding: 12px 65px;
    }

    .btn-outline-success-blue{
        padding: 12px 20px;
    }
   
`;

export const NonprofitsBoxTitle = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
`;

export const NonprofitsBoxText = styled.p`
    margin: 0px;
`;

export const NonprofitsBoxSpan = styled.span`
    color: #01606F;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 28px;
    cursor: pointer;
`;

export const SpecialThanksSec = styled.section`
    width: 100%;
    background: #F1FEFF; 
    padding: 50px 0px;
    @media screen and (max-width: 767px){
        padding: 40px 0px;
    }
`;

export const SpecialThanksWrap = styled.div`
    width: 100%;
    padding: 15px;
    background: #F3F3F3;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 40px;
    text-align: center;
    @media screen and (max-width: 991px){
        column-gap: 20px;
        flex-direction: column;
        align-items: center;
        row-gap: 20px;
    }
`;

export const SpecialThanksText = styled.h3`
    max-width: 230px;
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-left: 29px;
    text-align: left;

    @media screen and (max-width: 991px){
        max-width: inherit;
        margin-left: 0px;
        font-size: 26px;
        line-height: 40px;
    }
    @media screen and (max-width: 575px){
        font-size: 22px;
        line-height: 36px;
    }
`;

export const SpecialThanksImageWrap = styled.div`
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    gap: 10px 15px;
    
    @media screen and (max-width: 1200px){
        justify-content: flex-end;
    }

    @media screen and (max-width: 991px){
        justify-content: flex-start;
    }

`;

export const SpecialThanksImageBox = styled.div`
    width: 100%;
    max-width: 428px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    @media screen and (max-width: 1200px){
        max-width: 354px;
    }
    @media screen and (max-width: 1024px){
        max-width: 300px;
    }
    @media screen and (max-width: 991px){
        max-width: inherit;
        width: calc(50% - 8px);
    }
    @media screen and (max-width: 480px){
        width: 100%;
        padding: 15px;
    }
`;

export const TopAwardLatestNewsSec = styled.div`
    background: transparent linear-gradient(292deg, #F7931E 0%, #33A7AE 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 0px;
    padding: 30px 0 48px;
    
    @media screen and (max-width: 767px){
        padding: 30px 0px;
    }

    form .btn-outline-success-blue.form-btn{
        padding: 12px 65px;
    }

    .latest-news-in-container{
        background: transparent;
        box-shadow: none;
        border-radius: 0;
        padding: 0;
        margin-top: 0px;

        .form-flex {    
            display: flex;
            align-items: flex-start;
            width: 100%;
            column-gap: 24px;

            @media screen and (max-width: 767px){
                flex-direction: column;
                row-gap: 20px;
            }

            .form-input-group{
                width: 100%;
            }
        }
        .input-group-checkbox{
            margin-bottom: 0px;

            @media screen and (max-width: 480px){
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
            }
        }
    }

    form{
        .input-group {
            .input-form-group {
                .form-control{
                    padding: 10px 30px;
                }
            }
        }
    }
    .form-check-input{
        &:focus{
            box-shadow: none;
        }
    }
`;